export const ModulePermissionPrefix = {
  PRODUCTS_AND_EVENTS: 'LM_',
  RELEASE: 'DRM_',
  STATIC_DATA: 'SD_',
  INGESTION:'DI_',
  RULES:'RP_'
};
